import Icon from '../../components/Icon.vue'

Icon.register({"regular/caret-square-down":{"width":448,"height":512,"paths":[{"d":"M125.1 208H322.9C333.6 208 339 221 331.4 228.5L232.5 326.8C227.8 331.5 220.3 331.5 215.6 326.8L116.7 228.5C109 221 114.4 208 125.1 208zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM400 426V86C400 82.7 397.3 80 394 80H54C50.7 80 48 82.7 48 86V426C48 429.3 50.7 432 54 432H394C397.3 432 400 429.3 400 426z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/caret-square-down.js
// module id = 7mwU
// module chunks = 0